/**
 * Created by slava on 2/9/19
 */

// Mission.TYPE_LANTERN = 9;
// Mission.TYPE_LEVELPASS = 15;
// Mission.TYPE_BUILDPASS = 15;
// Mission.TYPE_BONUS_WORLD = 19;
// Mission.TYPE_LIVESFEAST = 20;
// Mission.TYPE_SLOT_MACHINE = 21;
// Mission.TYPE_SOFTFEAST = 22;
// Mission.TYPE_BOOSTTIME = 23;
// Mission.TYPE_CHESTTIME = 24;
// Mission.TYPE_SALEPASS = 25;
// Mission.TYPE_KRAKENFEAST = 26;
Mission.TYPE_SLOT2_PASS = 28;
Mission.TYPE_SLOT1_FEAST = 30;
Mission.TYPE_SLOT2_FEAST = 33;
Mission.TYPE_SLOT1_PASS = 34;
// Mission.TYPE_CARAVAN = 42;
// Mission.TYPE_EXPEDITION_PASS = 44;
// Mission.TYPE_EXPEDITION_FEAST = 45;
// Mission.TYPE_SNAIL_FEAST = 47;
// Mission.TYPE_COLLECTIONS_PASS = 66;
// Mission.TYPE_PINBALL = 67;
// Mission.TYPE_OCTOPUS_HUNT = 70;
// Mission.TYPE_KINGSCUP = 74;
// Mission.TYPE_SPACE_RACE = 77;
Mission.TYPE_LIGHTNING_RUSH = 78;
// Mission.TYPE_ISLAND_DECORATION = 93;
// Mission.TYPE_HUNGRY_GAMES = 94;
// Mission.TYPE_SEASON_PASS = 95;
// Mission.TYPE_LORYS_DERBY = 96;
// Mission.TYPE_LEVEL_MASTERY = 102;
// Mission.TYPE_BALLOON_RISE = 104;
// Mission.TYPE_MERGE2_MISSION = 105;
// Mission.TYPE_OLD_PIGGY_BANK = 65;
// Mission.TYPE_PIGGY_BANK = 106;
// Mission.TYPE_ROYAL_LEAGUE = 107;

Mission.MISSION_TYPE_BY_LOCATION_ID = {};

Mission.OBSOLETE_TYPES = [
    0, 1, 2,
    3, 4, 5, 6, 8, 11, 12, 13, 14, 16, 17, 27, 29, 35, 36, 37, 38, 39, 41, 43, 51, 56, 50, 53, 54,
    32, "32v1", 40, "40v1", 46, "46v1", 48, 49, 52, 55, "55v1", "55v2", 58, 59, 60, "60v1", "60v2", 61,
    "61v1", "61v2", "61v3", 62, 63, "63v1", 68, 69, 71, "71v1", 72, 73, 75, "75v1", 76, 79, 80,
    81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, // old island_decoration types
    64 // butterfly
];

const Missions = {};

Mission.SEMAPHORE_ALWAYS = 0;
Mission.SEMAPHORE_PRIMARY = 1;
Mission.SEMAPHORE_SECONDARY = 2;
Mission.SEMAPHORE_CUSTOM_LANTERN = 4;
Mission.SEMAPHORE_CUSTOM_PIGGY_BANK = 8;
Mission.SEMAPHORE_CUSTOM_SALE = 16;
Mission.SEMAPHORE_CUSTOM_PRIZE_CALENDAR = 32;

Mission.SEMAPHORE_COOLDOWNS = {};
Mission.SEMAPHORE_COOLDOWNS[Mission.SEMAPHORE_PRIMARY] = "1 hour";
if (cleverapps.config.type === "board") {
    Mission.SEMAPHORE_COOLDOWNS[Mission.SEMAPHORE_PRIMARY] = "2 day";
}
// merge games have only the kraken and soft feasts on it, an hour would chain them back to back
if (cleverapps.config.type === "merge") {
    Mission.SEMAPHORE_COOLDOWNS[Mission.SEMAPHORE_PRIMARY] = "1 day";
}
Mission.SEMAPHORE_COOLDOWNS[Mission.SEMAPHORE_SECONDARY] = "2 day";
Mission.SEMAPHORE_COOLDOWNS[Mission.SEMAPHORE_CUSTOM_LANTERN] = "5 day";
Mission.SEMAPHORE_COOLDOWNS[Mission.SEMAPHORE_CUSTOM_PIGGY_BANK] = "2 day";
Mission.SEMAPHORE_COOLDOWNS[Mission.SEMAPHORE_CUSTOM_PRIZE_CALENDAR] = "3 day";

Mission.SEMAPHORE_COOLDOWNS[Mission.SEMAPHORE_CUSTOM_SALE] = "14 day";

Mission.REGISTRATIONS = new Map();

const BaseMissionData = () => ({
    available: cleverapps.config.availables.BASE_MISSION,
    view: MissionWindow,
    duration: "1 day",
    prize: RewardsConfig.Tournament.places,
    teaser: true
});

Mission.initialize = function () {
    if (cleverapps.config.type === "merge") {
        Meta.REGISTER_MISSIONS_PER_LOCATION();
    }

    Mission.REGISTRATIONS.forEach((init, id) => {
        Missions[id] = init();
    });

    const missions = Object.keys(Missions).filter((type) => typeof Missions[type] === "object");

    missions.forEach((missionType) => {
        missionType = cleverapps.castType(missionType);

        const missionData = Missions[missionType];
        missionData.type = missionType;
    });

    const checkIllegal = function (type) {
        return type === undefined || (type.includes && type.includes("undefined"));
    };

    missions.forEach((type, ind) => {
        if (checkIllegal(type)) {
            cleverapps.throwAsync(`Undefined mission type ${type} ind: ${ind}`);
        }
    });
};

if (typeof cc === "undefined") {
    module.exports = {
        Missions,
        Mission
    };
}
